import { useLocation, useHistory } from 'react-router';

export const withRouter = Component => props => {
    const location = useLocation();
    const history = useHistory();

    return <Component location={location} history={history} {...props} />;
};
